/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { Download, Paperclip } from "react-feather";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Container, Form, FormGroup, Label, Row } from "reactstrap";
import * as Yup from "yup";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import TicketZoneSelector from "../../components/TicketZoneSelector";
import CreateTicketInBehalf from "../../components/TicketZoneSelector/createInBehalf";
import { useAuth } from "../../context/AuthContext";
import { useFiles } from "../../hooks/useFiles";
import { handleErrors } from "../../services/handleErrors";
import { postTicketing, postTicketingOnBehalf } from "../../services/ticketingServices";
import { getSubmotivoFile } from "../../services/fileServices";
import { handleClickFile } from "../../components/RelevosInfoGeneral/utils";
import { StyledSpinnerButton } from "../../ui/buttons";

const TicketingNew = ({ history }) => {
  const { refreshToken, currentUser } = useAuth();
  const [isLoadingEditor, setIsLoadingEditor] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [, handleUploadFileButton, saveFiles] = useFiles();
  const [spinnerState, setSpinnerState] = useState(true);
  const [userToCreateTicket, setUserToCreateTicket] = useState("");
  const [isOnBehalf, setisOnBehalf] = useState(false);
  const [disclaimer, setDisclaimer] = useState("");
  const [isSubmotivoFileLoading, setIsSubmotivoFileLoading] = useState(false);

  const handleConfirmSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const ticketZoneMount = () => {
    setSpinnerState(false);
  };

  const handleSetOnBehalf = () => {
    setisOnBehalf(!isOnBehalf);
  };

  const formik = useFormik({
    initialValues: {
      asignacion2: null,
      sucursaldepartamentoAsignado: null,
      motivo: null,
      submotivo: null,
      solicitud: "",
      categoria: null,
      nombre: "",
      apellido: "",
      email: "",
      piAsignado: null,
    },
    onSubmit: async (ticket) => {
      try {
        const { message, result } = isOnBehalf ? await postTicketingOnBehalf(ticket) : await postTicketing(ticket);
        if (selectedFiles.length > 0) {
          try {
            if (result.solicitudMessageId) {
              await saveFiles({ entity: "message", entityId: result.solicitudMessageId });
            } else {
              await saveFiles({ entity: "ticketing", entityId: result.ticket.itemId });
            }
          } catch (error) {
            let errMsg = "";
            handleErrors(
              error,
              (msg) => {
                errMsg = msg;
              },
              refreshToken,
              formik
            );
            toast.error(`Error subiendo los archivos, intente luego desde el detalle del ticket. ${errMsg}`);
          }
        }
        toast.success(message);
        history.push("/ticketing?mode=my");
      } catch (error) {
        handleErrors(error, toast.error, refreshToken, formik);
      }
    },
    validationSchema: Yup.object().shape({
      asignacion2: Yup.number().typeError("Debe seleccionar un sector de la lista").required("Este campo es requerido."),
      sucursaldepartamentoAsignado: Yup.mixed().when("asignacion2", (asignacion2) => {
        if (asignacion2 === 1) {
          return Yup.number().typeError("Debe seleccionar un departamento de la lista").required("Este campo es requerido.");
        }
        if (asignacion2 === 2) {
          return Yup.number().typeError("Debe seleccionar una sucursal de la lista").required("Este campo es requerido.");
        }
        return Yup.mixed().required("Este campo es requerido.");
      }),
      motivo: Yup.number().typeError("Debe seleccionar un motivo de la lista").required("Este campo es requerido."),
      submotivo: Yup.number().typeError("Debe seleccionar un sub motivo de la lista").required("Este campo es requerido."),
      solicitud: Yup.string().required("Este campo es requerido."),
      piAsignado: Yup.number().nullable().optional(),
      categoria: Yup.mixed().when(() => {
        if (isOnBehalf) {
          return Yup.number().typeError("Debe seleccionar un publico").required("Este campo es requerido.");
        }
        return Yup.number().nullable().optional();
      }),
      nombre: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el nombre.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      apellido: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el apellido.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      dniCreador: Yup.mixed().when("categoria", (categoria) => {
        if (isOnBehalf && categoria === 1) {
          return Yup.number().typeError("Debe completar el DNI.").required("Este campo es requerido.");
        }
        return Yup.number();
      }),
      email: Yup.mixed().when(() => {
        if (isOnBehalf && formik.values.piAsignado === null) {
          return Yup.string().typeError("Debe completar el email.").required("Este campo es requerido.");
        }
        return Yup.string();
      }),
      telefonoCreador: Yup.mixed().when((telefonoCreador) => {
        if (isOnBehalf && telefonoCreador !== "null") {
          return Yup.number();
        }
        return Yup.number();
      }),
    }),
  });

  useEffect(() => {
    if (currentUser) {
      const user = `${currentUser.user.nombre} ${currentUser.user.apellido}`;
      setUserToCreateTicket(user);
    }
  }, []);

  const handleDownloadTemplateFile = async (submotivoId) => {
    setIsSubmotivoFileLoading(true);

    try {
      const { result } = await getSubmotivoFile({ submotivoId });

      if (result && result.length > 0 && result[0]) {
        try {
          const file = { FileRels: result[0] };

          await handleClickFile(file);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      } else {
        toast.error("No se encontro el archivo");
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setIsSubmotivoFileLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>PIN - Nuevo Ticket</title>
      </Helmet>
      <Breadcrumb title="Nuevo Ticket" parent="Sistema de Ticketing" backButton />
      <BlurSpinner isLoading={formik.isSubmitting || isLoadingEditor || spinnerState}>
        <Container fluid>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col className="mb-4">
                <Card className="h-100">
                  <CardHeader>
                    <h5>Cargue los datos del nuevo ticket</h5>
                    En base al destinatario del ticket, por favor completar el formulario seleccionando las opciones correspondientes
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col lg="4" className="h-100">
                        <CreateTicketInBehalf createInBehalf={userToCreateTicket} formik={formik} setisOnBehalf={handleSetOnBehalf} isOnBehalf={isOnBehalf} />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4" className="h-100">
                        <TicketZoneSelector formik={formik} mounted={ticketZoneMount} setDisclaimer={setDisclaimer} />
                        <FormGroup>
                          <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                            <input
                              id="upfile"
                              type="file"
                              onChange={handleConfirmSelectedFiles}
                              multiple
                              accept="image/jpeg,image/gif,image/png,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            />
                          </Form>
                          <Label label className="col-form-label pt-0 w-100">
                            Adjuntar archivos
                          </Label>
                          <div className="d-flex justify-content-between">
                            <Button color="link" size="xs" onClick={handleUploadFileButton}>
                              <Paperclip size="24" />
                            </Button>
                            {formik && formik.values.submotivo && (
                              <StyledSpinnerButton
                                style={{ minWidth: "200px", color: "#fff", background: "#f0292a" }}
                                type="button"
                                isLoading={isSubmotivoFileLoading}
                                onClick={() => handleDownloadTemplateFile(formik.values.submotivo)}
                              >
                                Descargar template <Download size="14" />
                              </StyledSpinnerButton>
                            )}
                          </div>
                          {selectedFiles.length > 0 ? (
                            <div className="normalized_ul">
                              <Label className="col-form-label pt-0 w-100">Archivos adjuntos</Label>
                              <ul>
                                {Array.from(selectedFiles).map((file) => (
                                  <li>{file.name}</li>
                                ))}
                              </ul>
                            </div>
                          ) : (
                            <></>
                          )}
                        </FormGroup>
                      </Col>
                      {/* </BlurSpinner> */}
                      <Col lg="8" className="h-100 mb-0">
                        {disclaimer !== "" ? (
                          <Col className="mx-0 p-0 w-100" style={{ textAlign: "justify" }}>
                            {disclaimer}
                          </Col>
                        ) : (
                          <></>
                        )}
                        <Label label htmlFor="motivo" className="col-form-label pt-0 w-100">
                          Solicitud
                        </Label>
                        <FormGroup className="normalized_ul">
                          <CKEditor
                            editor={ClassicEditor}
                            config={{
                              removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                            }}
                            data={formik.values.solicitud}
                            onReady={() => setIsLoadingEditor(false)}
                            onChange={(event, editor) => formik.setFieldValue("solicitud", editor.getData())}
                            onBlur={() => formik.setFieldTouched("solicitud")}
                          />
                          {formik.errors.solicitud && formik.touched.solicitud && <div className="input-feedback">{formik.errors.solicitud}</div>}
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <FormGroup className="mb-0">
                      <Button type="submit">Enviar</Button>
                    </FormGroup>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Form>
        </Container>
      </BlurSpinner>
    </>
  );
};

export default withRouter(TicketingNew);
